import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Slider from './Slider'; // Make sure the path to the Slider component is correct

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Slider startIndex={0}/>} />
        <Route path="/contacto" element={<Slider startIndex={2}/>} />
        <Route path="/app" element={<Slider startIndex={0}/>} />
        <Route path="/carta" element={<Slider startIndex={1} />} />
      </Routes>
    </Router>
  );
};

export default App;
